<template>
  <div class="container-fluid">
    <div class="alert alert-danger alert-margin" role="alert" v-if="isMessage">
      {{ message }}
    </div>
    <div id="title" class="row">
      <div class="col-1">
        <svg id="header" class="bd-placeholder-img mr-2 rounded" width="28" height="28" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" focusable="false" role="img" aria-label="Placeholder: 32x32">
        <rect width="100%" height="100%" fill="#00C3E0"></rect>
        </svg>
      </div>
      <div class="col-5">
        <h5>パスワードポリシー設定</h5>
      </div>
    </div>
    <div id="register_form" class="row">
      <div class="col-1"></div>
      <div class="col-8">
        <form @submit.prevent="submit">
          <div class="form-group">
            <div class="row">
              <div class="col-10 label-container">
                <label class="label-content">最小桁数</label>
              </div>
              <div class="col-2">
                <input type="number" v-model="passwordPolicy.minimumLength" class="form-control" required min="6" max="20">
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-10 label-container">
                <label class="label-content">英字（大文字）</label>
              </div>
              <div class="col-2">
                <input type="checkbox" class="form-control" v-model="passwordPolicy.requireUpperCase" v-on:change="changeBelongs">
              </div>
            </div>  
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-10 label-container">
                <label class="label-content">英字（小文字）</label>
              </div>
              <div class="col-2">
                <input type="checkbox" class="form-control" v-model="passwordPolicy.requireLowerCase" v-on:change="changeBelongs">
              </div>
            </div>  
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-10 label-container">
                <label class="label-content">数字</label>
              </div>
              <div class="col-2">
                <input type="checkbox" class="form-control" v-model="passwordPolicy.requireDigits" v-on:change="changeBelongs">
              </div>
            </div>  
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-10 label-container">
                <label class="label-content">特殊文字（使用可能な文字： @/:~?!#%$）</label>
              </div>
              <div class="col-2">
                <input type="checkbox" class="form-control" v-model="passwordPolicy.requireSpecialChars" v-on:change="changeBelongs">
              </div>
            </div>
          </div>
          <button id="submit" type="submit" class="btn btn-info btn btn-block">{{ submitButtonText }}</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import authority from '../../authority';
import { sessions } from '../../mixin/session'
import { path } from '../../mixin/path'
import { headers } from '../../mixin/headers'

export default{
  name: 'Modify',
  mixins: [sessions, path, headers],
  props: ['realms'],
  src: { authority },
  data: function(){
    return {
      message: "",
      passwordPolicy: {
        minimumLength: 6,
        requireUpperCase: false,
        requireLowerCase: false,
        requireDigits: false,
        requireSpecialChars: false
      },
      submitButtonText: "更新する",
      existPolicy: true
    }
  },
  mounted() {
    if(this.$store.getters.hospital.id !== 0){
      this.search()
    }
    this.$store.watch(
      (state, getters) => getters.hospital,
      (newValue, oldValue) => {
        if (newValue.id != oldValue.id) {
          this.search()
        }
      }
    )
  },
  computed: {
    isMessage: function () {
      return this.message.length > 0
    }
  },
  methods: {
    async search() {
      try {
        const session = await this.$cognito.isAuthenticated();
        if (!session) {
          this.$router.replace(this.replacePath(this.$cognito,this.realms, '/login'));
        } else {
          const accessToken = await this.getAccessToken(this.$cognito, session);
          const hospitalId = this.$store.getters.hospital.id;
          const response = await axios.get(
            "/api/hospital/management/password/policy/"+hospitalId,
            { headers: this.headers(accessToken) }
          );
            
          if (response.data.errorMessage) this.message = response.data.errorMessage;
          else if (response.data.data.passwordPolicy == null) {
            this.submitButtonText = "登録する";
            this.existPolicy = false;
            this.initializePolicy();
            this.message = "パスワードポリシーが設定されていません。登録をしてください。";
          }
          else {
            this.passwordPolicy = response.data.data.passwordPolicy;
            this.message = "";
          }
        }
      } catch (error) {
        this.message = error.message;
      }
    },
    initializePolicy() {
      this.passwordPolicy.minimumLength = 6;
      this.passwordPolicy.requireUpperCase = false;
      this.passwordPolicy.requireLowerCase = false;
      this.passwordPolicy.requireDigits = false;
      this.passwordPolicy.requireSpecialChars = false;
    },
    async submit() {
      try {
        const session = await this.$cognito.isAuthenticated();
        if (!session) {
          this.$router.replace(this.replacePath(this.$cognito,this.realms, '/login'));
        } else {
          const accessToken = await this.getAccessToken(this.$cognito, session);
          const passwordPolicy = {
            minimumLength: this.passwordPolicy.minimumLength,
            requireUpperCase: this.passwordPolicy.requireUpperCase,
            requireLowerCase: this.passwordPolicy.requireLowerCase,
            requireDigits: this.passwordPolicy.requireDigits,
            requireSpecialChars: this.passwordPolicy.requireSpecialChars
          }
          if (this.existPolicy) this.update(accessToken, passwordPolicy);
          else this.register(accessToken, passwordPolicy);
        }
      } catch (error) {
        this.message = error.message;
      }
    },
    async register(accessToken, passwordPolicy) {
      const response = await axios.post(
        "/api/hospital/management/password/policy",
        {
          hospitalId: this.$store.getters.hospital.id,
          hospitalCode: this.$store.getters.hospital.code,
          passwordPolicy: passwordPolicy
        },
        { headers: this.headers(accessToken) }
      );
      if (response.data.errorMessage) this.message = response.data.errorMessage;
      else {
        alert('登録されました。');
        this.message = "";
        this.passwordPolicy = response.data.data.passwordPolicy;
        this.submitButtonText = "更新する";
        this.existPolicy = true;
      }
    },
    async update(accessToken, passwordPolicy) {
      const response = await axios.put(
        "/api/hospital/management/password/policy",
        {
          hospitalId: this.$store.getters.hospital.id,
          hospitalCode: this.$store.getters.hospital.code,
          passwordPolicy: passwordPolicy
        },
        { headers: this.headers(accessToken) }
      );
      if (response.data.errorMessage) this.message = response.data.errorMessage;
      else {
        alert('更新されました。');
        this.message = "";
      }
    }
  }
}
</script>

<style scoped>
#header {
  float: right;
}
#title {
  padding: 10px;
}
#main {
  height: 100%;
}
.alert-margin {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.label-container {
  display: flex;
  align-items: center;
}
.label-content {
  margin: 0 0 0 0;
}
</style>